import { useContext, useState } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AuthContext } from '../../../../../../lib/context/AuthContext';
import EditIcon from '@mui/icons-material/Edit';
import { IconButton } from '@mui/material';
import {
  MainWrapper,
  TitleWrapper,
  InfosWrapper,
  InfoWrapper,
  WrapperInfoIcon,
  IconButtonWrapper,
  Title,
  Type,
  Date,
  Desc,
} from '../styles';
import AddEducation from './AddEducation/AddEducation';
import EditEducation from './EditEducation/EditEducation';
import { useTranslation } from 'react-i18next';
import { formatDateWithNumbers } from '../../../../../../utils/formaters/formatDate';

export default function Educations() {
  const { user } = useContext(AuthContext);
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);
  const [openEditModal, setOpenEditdModal] = useState<boolean>(false);
  const [item, setItem] = useState<any>();
  const { t } = useTranslation();
  return (
    <MainWrapper>
      <TitleWrapper>
        <Title>{t('more_info.educations')}</Title>
        <IconButton>
          <AddCircleIcon onClick={() => setOpenAddModal(true)} />
        </IconButton>
      </TitleWrapper>
      {user && user.educations && user.educations.length > 0 ? (
        user.educations.map((field, index) => {
          return (
            <InfosWrapper key={index}>
              <WrapperInfoIcon>
                <InfoWrapper>
                  <Type>{field.educationName}</Type>
                  <Date>
                    {formatDateWithNumbers(
                      field.startMonth,
                      field.startYear,
                      field.endMonth,
                      field.endYear
                    )}
                  </Date>
                </InfoWrapper>
                <InfoWrapper>
                  <Desc>{field.fieldOfStudy}</Desc>
                </InfoWrapper>
              </WrapperInfoIcon>
              <IconButtonWrapper size="small">
                <EditIcon
                  onClick={() => {
                    setOpenEditdModal(true);
                    setItem(field);
                  }}
                />
              </IconButtonWrapper>
            </InfosWrapper>
          );
        })
      ) : (
        <Type>
          {t('editProfile.edit_candidate_profile.education.no_educations')}
        </Type>
      )}
      <EditEducation
        field={item}
        open={openEditModal}
        setOpen={setOpenEditdModal}
      />
      <AddEducation
        setItem={setItem}
        open={openAddModal}
        setOpen={setOpenAddModal}
      />
    </MainWrapper>
  );
}
